import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PermissionManagerContent from '../components/PermissionManagerContent';

export default function OrgAdminPermissionsPage() {
  const [searchParams] = useSearchParams();
  const initialUserId = searchParams.get('userId') || '';

  return <PermissionManagerContent initialUserId={initialUserId} />;
}
